export enum eReducerStatusBase {
    is_not_initialization = "is_not_initialization",
    is_loading = "is_loading",
    is_completed = "is_completed",
    is_error = "is_error",
    is_need_reload = "is_need_reload",
}
